import React from 'react'
import classNames from 'classnames'
import TermsAndConditions from '../common/TermsAndConditions'

interface AutoPayPolicyModal {
  isOpen: boolean
  onClose: () => void
}

const AutoPayPolicyModal = ({isOpen, onClose}: AutoPayPolicyModal) => {
  return (
    <div
      className={classNames({
        modal: true,
        'modal-open': isOpen
      })}
    >
      <div className="modal-box p-8">
        <h1 className="modal-header">Terms and Conditions</h1>
        <div className="h-80 p-4 border overflow-y-auto">
          <TermsAndConditions />
        </div>
        <div className="modal-action">
          <button className="btn btn-primary" onClick={e => onClose()}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default AutoPayPolicyModal
